<template>
  <div class="headerTeacher">
    <el-row>
      <el-col :span="16" :offset="3">
        <div class="headerTeacher-title">
          <div class="headerTeacher-title-left">教师后台管理系统</div>
          <del></del>
          <div class="headerTeacher-title-right">
            <div style="font-weight: 700">
              <span>{{ personInfo.title }}</span
              >老师，欢迎你！进入学习网
            </div>

          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getStore } from "@/utils/localStorage";
export default {
  name: "headerTeacher",
  data() {
    return {
      options: [],
      value: "",
      personInfo: JSON.parse(getStore("userInfo")),
    };
  },
  created() {
    this.options = this.personInfo.teacher_type_array;
    if(this.options){
      this.options=3
    }
    let teacherRole = this.$store.state.common.teacherRole;

    this.value = teacherRole ? teacherRole : this.options;
  },
  methods: {


  },
};
</script>

<style lang="scss" scoped>
.headerTeacher {
  height: $headH;
  width: 100%;
  overflow: hidden;
  background: url("../../assets/images/教师头部背景.png") no-repeat center
    center;

  .el-row {
    height: 100%;
    @include linearGradient("linear-gradient-start", "linear-gradient-end");

    .el-col {
      height: 100%;
      /*左边部分*/
      .headerTeacher-title {
        display: flex;
        align-items: center;
        height: 100%;
        color: #ffffff;

        .headerTeacher-title-left {
          font-size: 34px;
          font-weight: 700;
        }

        del {
          width: 1px;
          height: 35%;
          background-color: #ffffff;
          margin: 0 10px;
        }

        .headerTeacher-title-right {
          /deep/ .el-input__inner {
            background-color: rgba(0, 0, 0, 0);
            border-radius: 0;
            // height: 30px;
            color: #ffffff;
          }

          /deep/ .el-input__inner:focus {
            border-color: #ffffff;
          }

          /deep/ .el-input__icon {
            line-height: 0;
          }
        }
      }
    }
  }
}
</style>
